import { Zap, HardHat } from 'lucide-react';

const MODULES = [
    { key: 'easy_power', label: 'Courtage', Icon: Zap },
    { key: 'chantier', label: 'Travaux', Icon: HardHat },
];
const TONES = {
    won: 'text-emerald-700 bg-emerald-50', lost: 'text-red-700 bg-red-50',
    in_progress: 'text-sky-800 bg-sky-50', inactive: 'text-slate-500 bg-slate-100',
};

export const DossierModuleStatuses = ({ dossier }) => (
    <div className="grid min-w-0 grid-cols-1 sm:grid-cols-2 gap-2 px-3 pb-3" data-testid={`dossier-modules-${dossier.id}`}>
        {MODULES.map(({ key, label, Icon }) => {
            const module = dossier.modules?.[key];
            return (
                <div key={key} className={`flex min-w-0 items-start gap-2 rounded-md px-2.5 py-2 text-xs ${TONES[module?.status] || TONES.inactive}`}
                    data-testid={`dossier-module-${key}-${dossier.id}`}>
                    <Icon className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden="true" />
                    <div className="min-w-0 break-words">
                        <span className="block font-semibold" data-testid={`dossier-module-name-${key}-${dossier.id}`}>{label}</span>
                        <span data-testid={`dossier-module-status-${key}-${dossier.id}`}>{module?.label || 'Statut indisponible'}</span>
                    </div>
                </div>
            );
        })}
    </div>
);

export const ModuleStatusSummary = ({ counts }) => !counts ? null : (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4 border-y border-slate-200 py-4" data-testid="parrainage-module-summary">
        {MODULES.map(({ key, label, Icon }) => (
            <div key={key} className="min-w-0 space-y-2" data-testid={`module-summary-${key}`}>
                <p className="flex items-center gap-2 text-sm font-semibold text-slate-800"><Icon className="h-4 w-4" aria-hidden="true" />{label}</p>
                <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs">
                    {[['in_progress', 'en cours'], ['won', 'gagné(s)'], ['lost', 'perdu(s)'], ['inactive', 'inactif(s)']].map(([status, text]) => (
                        <span key={status} data-testid={`module-summary-${key}-${status}`} className="text-slate-600"><strong>{counts[key]?.[status] || 0}</strong> {text}</span>
                    ))}
                </div>
            </div>
        ))}
    </div>
);